import { environment } from './environment/environment';

export const apiBaseUrl = environment.apiBaseUrl;
export const amBaseUrl = environment.amBaseUrl;
export const apiVersion = environment.apiVersion;
export const versionInfo = environment.versionInfo;
export const isProdMode = environment.production;
